import React from "react";
import { Grid, Button } from "@mui/material";

import { APIWatchersService } from "../../../../api";
import UpdateAllTables from "./components/UpdateAllTables";

const WatchersService = (): React.ReactElement => {
  const handleUpdateTraderIdDb = async () => {
    await APIWatchersService.updateTraderIdDb();
  };
  const handleUpdateWatchlistNotesTable = async () => {
    await APIWatchersService.updateWatchlistNotesTable();
  };
  const handleUpdateWithdrawalsTable = async () => {
    await APIWatchersService.updateWithdrawalsTable();
  };
  const handleUpdateWatchlistTcpSteps = async () => {
    await APIWatchersService.updateWatchlistTcpSteps();
  };
  const handleUpdateWatchlistGmCappers = async () => {
    await APIWatchersService.updateWatchlistGmCappers();
  };
  const handleUpdateMasterBanList = async () => {
    await APIWatchersService.updateMasterBanList();
  };
  const handleUpdateFinancialsTables = async () => {
    await APIWatchersService.updateFinancialsTables();
  };
  const handleUpdateFundedTradersTable = async () => {
    await APIWatchersService.updateFundedTradersTable();
  };
  const handleUpdateEvaluationCompletedHistoryTable = async () => {
    await APIWatchersService.updateEvaluationCompletedHistoryTable();
  };
  const handleUpdateTradedAccountsTable = async () => {
    await APIWatchersService.updateTradedAccountsTable();
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <UpdateAllTables />
        </Grid>

        {process.env.REACT_APP_NODE_ENV === "development" && (
          <>
            <Grid item xs={3}>
              <Button size="small" onClick={handleUpdateTraderIdDb}>
                Update Trader Id Db
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button size="small" onClick={handleUpdateWatchlistNotesTable}>
                Update Watchlist Notes Table
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button size="small" onClick={handleUpdateWithdrawalsTable}>
                Update Withdrawals Table
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button size="small" onClick={handleUpdateWatchlistTcpSteps}>
                Update Watchlist Tcp Steps
              </Button>
            </Grid>

            <Grid item xs={3}>
              <Button size="small" onClick={handleUpdateWatchlistGmCappers}>
                Update Watchlist Gm Cappers
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button size="small" onClick={handleUpdateMasterBanList}>
                Update Master Ban List
              </Button>
            </Grid>

            <Grid item xs={3}>
              <Button size="small" onClick={handleUpdateFinancialsTables}>
                Update Financials Tables
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button size="small" onClick={handleUpdateFundedTradersTable}>
                Update Funded Traders Table
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button size="small" onClick={handleUpdateEvaluationCompletedHistoryTable}>
                Update Evaluation Completed History Table
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button size="small" onClick={handleUpdateTradedAccountsTable}>
                Update Traded Accounts Table
              </Button>
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
};

export default WatchersService;
